<template>
<ModalCard @close="$emit('modalToggle','')">
    <template #title>
        برداشت از کیف پول تومان
    </template>
    <template #body>
        <div class="text"> جهت افزایش اعتبار کیف پول ریالی خود با استفاده از کارت های بانکی عضو شتاب و از طریق درگاه پرداخت,حتما باید از کارت های بانکی به اسم خودتان که در پروفایلتان ثبت و تایید شده است,استفاده نمایید</div>
        <LabelInput @input='value=>amount=value' type="number" label='مبلغ به تومان' />
        <div class="depsoit">
            <div>موجودی:</div>
            <div>{{$toLocal(cash,0)}} تومان</div>
        </div>

        <div>
            <div class="warning">
                <img src="../../assets/icons/red-warn.svg" />
                <div>درخواست‌های تسویه ریالی در روزهای تعطیل به دلیل تعطیلی بانک‌ها و عدم فعالیت سیستم پایا و ساتنا انجام نمی شود .</div>
            </div>
            <div class="card-select">
                <label class="text">شماره کارت:</label>
                <DropDown v-if="banksList" @choose="value=>walletAddress=value" :items="banksList" />
            </div>
            <div class="warning">
                <img src="../../assets/icons/red-warn.svg" />
                <div v-if="errorHandler">{{errorHandler}}</div>
                <div v-else>درخواست‌های تسویه بالای 100 میلیون تومان به دلیل محدودیت‌های بانکی حداکثر تا یک روز آینده کاری از زمان ثبت درخواست انجام خواهد شد .</div>
            </div>
        </div>
        <div class="text" v-if="otpInput"> کد تایید را وارد نمایید</div>
        <VerifyCodeInput v-if="otpInput" @change="e=>TwoStep_code=e" @complete="submitWithdrawRequest()" :num="6" />
        <div class="email-btn" v-if="otpInput &&  counter" :class="{disabled:disabled}">
            {{Math.floor(countDown/60)}}:{{countDown%60}}
        </div>
        <button class="modal-submit-btn" v-if="!otpInput" @click="withdraw()" :class="{disabled:disabled}" :disabled="disabled">
            ارسال کد تایید
        </button>

        <button v-if="otpInput && countDown===0 && counter" class="modal-submit-btn" @click.prevent="send()">
            ارسال مجدد
        </button>
        <button class="modal-submit-btn" v-if="countDown>0 && otpInput " :class="{disabled:disabled || !otpInput || countDown==0}" @click="submitWithdrawRequest()" :disabled="disabled || !otpInput || countDown==0">ثبت </button>
    </template>

</ModalCard>
</template>

<script>
import ModalCard from './ModalCard'
import DropDown from '../tools/DropDown'

export default {
    name: 'AddTicket',
    components: {
        ModalCard,
        DropDown

    },
    props: {

        cash: {
            default: function () {
                return 0
            }
        },
        wage: {
            default: 0
        },

    },

    computed: {
        banksList() {
            if (this.banks)
                return this.banks.map(bank => {
                    return {
                        label: bank.cardNumber,
                        value: bank.cardNumber
                    }
                })
            return false
        },
        cardFilter() {
            if (this.banks)
                return this.banks.filter(card => card.cardNumber.replace('-', '').startsWith(this.regex))
            else
                return []
        },
        disabled() {
            return !this.$S2N(this.amount) ||
                !this.walletAddress ||
                (this.$S2N(this.amount) > this.$S2N(this.cash)) ||
                (this.$S2N(this.amount) > this.$S2N(this.max)) ||
                (this.$S2N(this.amount) < this.$S2N(this.min))
            // ( !this.enable )
            // (!this.selected_net)
        },
        errorHandler() {
            if ((this.$S2N(this.amount) > this.$S2N(this.cash)))
                return 'موجودی کافی نمیباشد'
            else if ((this.$S2N(this.amount) < this.$S2N(this.min)))
                return 'مقدار برداشت باید حداقل' + this.$coins[this.relatedCoin].code + ' ' + this.$toLocal(this.min, 0) + 'باشد'
            else if ((this.$S2N(this.amount) > this.$S2N(this.max)))
                return 'مقدار برداشت باید حداکثر ' + this.$coins[this.relatedCoin].code + ' ' + this.$toLocal(this.max, 0) + ' باشد '
            else
                return ''

        },

    },
    data() {
        return {
            banksOptions: false,
            unit: "تومان",
            amount: 0,
            banks: [],
            regex: '',
            walletAddress: '',
            TwoStep_code: '',
            towStepAuthenticationType: '',
            transaction: {
                code: '',
                amount: '',
                relatedCoin: 'TOMAN',
                destinationWalletAddress: ''
            },
            counter:false,
            show: false,
            countDown: 120,
            otpInput: false,
            min: 0,
            max: 0

        }
    },
    methods: {
        chooseCard(cardNumber) {
            this.walletAddress = cardNumber
            this.regex = ''
            this.show = false
        },
        countDownTimer() {
            if (this.countDown > 0) {
                this.timeOut = setTimeout(() => {
                    this.countDown--
                    this.countDownTimer()
                }, 1000)
            } else {
                this.$error('زمان شما به اتمام رسید', '')
            }
        },
        async submitWithdrawRequest() {
            this.state.loading = true
            this.transaction.amount = this.$S2N(this.amount)
            this.transaction.destinationWalletAddress = this.walletAddress
            this.transaction.code = this.TwoStep_code
            const [res, ] = await this.$http.post(`/wallets/withdrawal-request`, this.transaction)
            if (res) {
                this.$error('درخواست شما با موفقیت ثبت شد', '', 'success')
                    ++this.state.requestChanged
                this.$emit('modalToggle', '')
            }
        },
        async getData() {
            this.state.loading = true
            const res = await this.$axios.get('/users/verified-bank-accounts')
            this.banks = res.content
            this.walletAddress = this.banks[0].cardNumber
            const coinsResponse = await this.$axios.get('/coins/details')
            this.coins = coinsResponse.content
            this.coinData = this.coins.find(coin => coin.coin == 'TOMAN')
            this.wage = this.coinData.tokenTypeDetails[0].withdrawalFee
            this.max = this.coinData.tokenTypeDetails[0].maxWithdraw
            this.min = this.coinData.tokenTypeDetails[0].minWithdraw

            console.log(this.coinData)

        },
        async withdraw() {
            if (!this.disabled && !this.state.loading) {
                const res = await this.$axios.post("/users/send-code")
                if (res.message === "code sent successfully.") {
                    this.otpInput = true
                    this.towStepAuthenticationType = res.baseDTO.towStepAuthenticationType
                    if (this.towStepAuthenticationType !== 'GOOGLE_AUTHENTICATOR') {
                        this.counter = true
                        this.countDownTimer()
                    }
                }
            }

        },

        async send() {
            this.TwoStep_code = ''

            this.state.loading = true
            const a = {
                EMAIL: 'ایمیل',
                SMS: 'شماره'
            }
            const res = await this.$axios.post("/users/send-code")
            this.towStepAuthenticationType = res.baseDTO.towStepAuthenticationType
            if (res.message === 'code sent successfully.') {
                this.$error('', 'کد به ' + a[this.towStepAuthenticationType] + ' شما ارسال شد', 'success')
                if (this.countDown === 0)
                    this.countDown = 120
                this.countDownTimer()
            }
        },
    },
    mounted() {
        this.getData()
    },
}
</script>

<style scoped>
.disabled {

    opacity: 0.7;
}

.text {
    font-size: clamp(12px, 1.3vw, 14px);
    color: var(--modal-text)
}

.warning {
    color: #FF2D78;
    font-size: clamp(11px, 1.1vw, 12px);
    font-family: 'YekanLight';
    display: flex;
    align-items: flex-start;
    column-gap: 7px;
}
.card-select{
    display: flex;
    column-gap: 6px;
    align-items: center;
    padding: 10px 0px;

}
.depsoit,
.depsoit * {
    display: flex;
    justify-content: space-between;
    column-gap: 16px;
    font-size: clamp(12px, 1.4vw, 14px);
    font-family: 'YekanLight';
    color: var(--modal-text)
}
</style>
